import { PricingModel, QuantityMetaType } from './types/pricing-table-types';

export const samplePricingTable = {
  id: 'pricingTable1',
  name: 'First Pricing page',
  grouped_by: 'item',
  frequencies: [
    {
      id: '01JASNM10X55F99TB9GDS1MAQS',
      title: 'Monthly',
      period: 1,
      period_unit: 'month',
      is_attached: true,
      display_order: 0,
      price_suffix: 'per month',
      recurring_price_label: 'Renews at {{price}} per month',
      show_monthly_price: false,
    },
    {
      id: '01JASNM10X5988XZ6XK0BE43XF',
      title: 'Yearly',
      period: 1,
      period_unit: 'year',
      is_attached: true,
      display_order: 1,
      price_suffix: 'per month billed Yearly',
      recurring_price_label: 'Renews at {{price}} per month billed Yearly',
      show_monthly_price: true,
    },
  ],
  currencies: [
    {
      id: 'USD',
      currency_code: 'USD',
      is_attached: true,
      display_order: 0,
    },
    {
      id: 'INR',
      currency_code: 'INR',
      is_attached: true,
      display_order: 2,
    },
  ],
  items: [
    {
      id: 'basic_plan',
      customization: {
        name: 'Basic Plan',
        display_name: 'Basic Plan',
        description:
          'This is a basic plan suitable for individuals and small teams.',
        features: `<div class="slate-p">What's included</div><ol class="slate-ol"><li class="slate-li"><div class="slate-p">access to core features</div></li><li class="slate-li"><div class="slate-p">email support</div></li><li class="slate-li"><div class="slate-p">limited analytics</div></li><li class="slate-li"><div class="slate-p"><s class="slate-strikethrough">no custom integrations</s></div></li></ol>`,
        highlight: true,
        badge: {
          type: 'block',
          text: 'Most Popular',
        },
        action_button: {
          type: 'redirect_to_url',
          url: 'https://example.com/basic',
          text: 'Choose Basic',
        },
        is_custom_amount_text: false,
        custom_amount_text: null,
        custom_amount_sub_text: null,
        quantity_meta: {
          min: 1,
          max: 7,
          step: 1,
          default_value: 1,
          unit_of_measure: {
            singular: null,
            plural: null,
          },
          type: QuantityMetaType.SLIDER,
        },
        info_text: 'Ideal for individuals',
      },
      is_metered: false,
      display_order: 0,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'basic_plan_123',
      billing_system_version: '1742300490000',
      is_attached: true,
      product_family: 'Google-drive',
      item_applicability: 'restricted',
      applicable_items: [
        'Charge2',
        'Charge4',
        'Addon5',
        'charge3',
        'Addon1',
        'charge1',
      ],
      attached_addons: [
        {
          billing_system_id: 'Addon5',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1752046160977',
          item_type: 'addon',
          quantity: 30,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Addon1',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1750750372653',
          item_type: 'addon',
          quantity: 2,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Charge4',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1750836994214',
          item_type: 'charge',
          quantity: 112,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Charge2',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1750087013779',
          item_type: 'charge',
          quantity: 20,
          type: null,
          charge_on_event: 'plan_activation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge3',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1750666077935',
          item_type: 'charge',
          quantity: 2,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge1',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1750923926907',
          item_type: 'charge',
          quantity: 1,
          type: null,
          charge_on_event: 'subscription_activation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: '01JASNM10Y4YK787YBVD1NSWQV',
          customization: {},
          name: 'Basic Plan INR Monthly',
          period: 1,
          period_unit: 'month',
          amount: 600,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 600,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-INR-Monthly',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1742300490000',
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          trial_period: null,
          trial_period_unit: null,
          tiers: null,
        },
        {
          id: 'usd_yearly_price_basic',
          name: 'USD Yearly Price',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 500,
          active: true,
          is_attached: true,
          strikethrough_amount: 600,
          billing_system_amount: 500,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'basic_usd_y',
          billing_system_item_id: 'basic_plan_123',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27NEANEJZKXAPNDMJ0B',
          name: 'Basic Plan USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 60,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 60,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-USD-Monthly',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27NKW8HDSTZD2TQ8N06',
          name: 'Basic Plan USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 120,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 120,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-USD-Yearly',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27NQ2FNP9JQMFTN0HCN',
          name: 'Basic Plan INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1300,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1300,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-INR-Yearly',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JQBFYVC34JC2E0XPE3JNAXYK',
          name: 'Basic Plan',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 0,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 0,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-905',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753956154846',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JRWCJTGPAN45GHCH919ZBR1G',
          name: 'Basic Plan INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-INR-Monthly-Volume',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          pricing_model: PricingModel.volume,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 25,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 10000,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 25,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 10000,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JSEHDSM1DR1Q2B35S7B84SVY',
          name: 'Basic Plan default',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 99,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 99,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-116',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JTSR50QY1QX90YXRS9P51901',
          name: 'Basic Plan USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-USD-Monthly-PerUnit',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JXKVR1M58YVXC0R54QZMMVRR',
          name: 'Basic-Plan',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 5000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 5000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-990',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: 'variant-3',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01K0BCVJCTD46CJSDNB3F4NA0V',
          name: 'Basic-Plan11',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-70811',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: 'fluxus-variant',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01K0BCVJCTD46CJSDNB3F4NA0W',
          name: 'Basic Plan USD Monthly - Variant A',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 65,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 65,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-USD-Monthly-A',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: 'variant-a',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01K0BCVJCTD46CJSDNB3F4NA0X',
          name: 'Basic Plan USD Monthly - Variant B',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 70,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 70,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-USD-Monthly-B',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: 'variant-b',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01K0BCVJCTD46CJSDNB3F4NA0Y',
          name: 'Basic Plan INR Monthly - Variant A',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 650,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 650,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Basic-Plan-INR-Monthly-A',
          billing_system_item_id: 'Basic-Plan',
          billing_system_version: '1753762709484',
          is_attached: true,
          price_variant_id: 'variant-a',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JASNM10YT8SST3E5W7T438PJ',
      customization: {
        name: 'Premium-Plan',
        display_name: null,
        description: '',
        features: `<div class="slate-p">What's included</div><ol class="slate-ol"><li class="slate-li"><div class="slate-p">priority support</div></li><li class="slate-li"><div class="slate-p">advanced analytics</div></li><li class="slate-li"><div class="slate-p">custom integrations</div></li><li class="slate-li"><div class="slate-p"><s class="slate-strikethrough">basic limitations removed</s></div></li></ol>`,
        highlight: true,
        badge: {
          type: 'block',
          text: 'Most Popular',
        },
        action_button: {
          type: 'redirect_to_url',
          url: 'https://example.com/gold',
          text: 'Choose Gold',
        },
        is_custom_amount_text: false,
        custom_amount_text: 'string',
        custom_amount_sub_text: 'string',
        quantity_meta: {
          min: 1,
          max: 10,
          step: 1,
          default_value: 1,
          unit_of_measure: null,
          type: QuantityMetaType.NONE,
        },
        info_text: 'Best for small to mid-sized teams',
      },
      is_metered: false,
      display_order: 1,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'gold_plan_456',
      billing_system_version: '1742300590000',
      is_attached: true,
      product_family: 'Netflix',
      item_applicability: 'all',
      applicable_items: [],
      attached_addons: [
        {
          billing_system_id: 'Addon4',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1751205201451',
          item_type: 'addon',
          quantity: 1,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Addon3',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1745315412091',
          item_type: 'addon',
          quantity: 1,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Addon2',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1745315437246',
          item_type: 'addon',
          quantity: 7,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Charge4',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1750887226838',
          item_type: 'charge',
          quantity: null,
          type: null,
          charge_on_event: 'subscription_trial_start',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge1',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1747825871785',
          item_type: 'charge',
          quantity: 88,
          type: null,
          charge_on_event: 'plan_activation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: '01JASNM10Y04TJ4RWQYN551A6T',
          name: 'Premium Plan INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 10000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-INR-Yearly',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195806925',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JASNM10Y7GYG7X90D2GSB5M6',
          name: 'Premium Plan INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 3000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 3000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-INR-Yearly-Alt',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195794395',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JASNM10YGFDDZM5388XHKD91',
          name: 'Premium Plan INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1200,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1200,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-INR-Monthly',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1745928071072',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MHMCGW786RTMB5PYQ',
          name: 'Premium Plan USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1000,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-USD-Yearly',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195835138',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MJFBHS39SMD81CC04',
          name: 'Premium Plan USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 300,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 300,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-USD-Yearly-Alt',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195826048',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MNRW6QVH4PB5QEJZK',
          name: 'Premium Plan USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 100,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 100,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-USD-Monthly',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195816086',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JSEHDSM14E6ZAZ8WEYDQD6XJ',
          name: 'Premium Plan INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-INR-Monthly-PerUnit',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1752056952097',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MNRW6QVH4PB5QEJZL',
          name: 'Premium Plan USD Monthly - Variant A',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 110,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 110,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-USD-Monthly-A',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195816086',
          is_attached: true,
          price_variant_id: 'variant-a',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MNRW6QVH4PB5QEJZM',
          name: 'Premium Plan USD Monthly - Variant B',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 120,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 120,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-USD-Monthly-B',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1732195816086',
          is_attached: true,
          price_variant_id: 'variant-b',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JEDFD27MNRW6QVH4PB5QEJZN',
          name: 'Premium Plan INR Monthly - Variant A',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1300,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1300,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Premium-Plan-INR-Monthly-A',
          billing_system_item_id: 'Premium-Plan',
          billing_system_version: '1745928071072',
          is_attached: true,
          price_variant_id: 'variant-a',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'Freemium Plan',
      customization: {
        name: 'Freemium Plan',
        display_name: null,
        description: '',
        features: `<div class="slate-p">What's included</div><ol class="slate-ol"><li class="slate-li"><div class="slate-p">dedicated account manager</div></li><li class="slate-li"><div class="slate-p">enterprise-level security</div></li><li class="slate-li"><div class="slate-p">24/7 premium support</div></li><li class="slate-li"><div class="slate-p">unlimited team members</div></li></ol>`,
        highlight: true,
        badge: {
          type: 'full',
          text: 'Enterprise Choice',
        },
        action_button: {
          type: 'redirect_to_url',
          url: 'https://example.com/premium',
          text: 'Choose Premium',
        },
        is_custom_amount_text: false,
        custom_amount_text: 'string',
        custom_amount_sub_text: 'string',
        quantity_meta: null,
        info_text: 'Perfect for enterprises',
      },
      is_metered: true,
      display_order: 2,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'premium_plan_789',
      billing_system_version: '1742300690000',
      is_attached: true,
      product_family: 'Google-Drive',
      item_applicability: 'all',
      applicable_items: [],
      attached_addons: [
        {
          billing_system_id: 'Extra-Space-Addon',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1745485809337',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Charge4',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1750923462367',
          item_type: 'charge',
          quantity: null,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'Charge2',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1750922186016',
          item_type: 'charge',
          quantity: 22,
          type: null,
          charge_on_event: 'subscription_trial_start',
          chargeOnce: false,
          display_order: null,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: '01JQ3GZN77B3M4X8M181VMQ563',
          name: 'Freemium Plan INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 500,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 500,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Freemium-Plan-INR-Yearly-Alt',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1742801363755',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 2,
          trial_period_unit: 'day',
        },
        {
          id: '01JQ3GZN77BAP983XBWF5YPHHH',
          name: 'Freemium Plan INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1200,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1200,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Freemium-Plan-INR-Yearly',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1742801401176',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 2,
          trial_period_unit: 'month',
        },
        {
          id: '01JQ3GZN77YE8YH3WXHE0YZK9A',
          name: 'Freemium Plan INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 94,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 94,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Freemium-Plan-INR-Monthly',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1742801339682',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 2,
          trial_period_unit: 'day',
        },
        {
          id: '01JTSR50QZ666CZQTWWH2GMZME',
          name: 'Freemium Plan INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1110,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1110,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Freemium-Plan-INR-Monthly-Alt',
          billing_system_item_id: 'Freemium-Plan',
          billing_system_version: '1750888171221',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 3,
          trial_period_unit: 'day',
        },
      ],
    },
  ],
  addons: [
    {
      id: '01JVPDAR7N35MN5SHPW00MW8YM',
      name: 'Addon4',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon4',
      billing_system_version: '1751205029782',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Addon4',
        display_name: 'Addon4',
      },
      prices: [
        {
          id: '01JVPDAR7NHXVX9F96PB6CAT0F',
          name: 'Addon4',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 90,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 90,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon4-423',
          billing_system_item_id: 'Addon4',
          billing_system_version: '1751205029785',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon4-423',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1751205133147',
              amount: 95,
              tiers: [],
            },
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon4-423',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1745227470418',
              amount: 90,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7P0TQP6F51AB53TKPX',
          name: 'Addon4 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 30,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 30,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon4-INR-Monthly',
          billing_system_item_id: 'Addon4',
          billing_system_version: '1751205029785',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon4-INR-Monthly',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1746799748862',
              amount: 80,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7PWYRR0YZB5J2D7YM7',
          name: 'Addon4 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon4-INR-Monthly-Tiered',
          billing_system_item_id: 'Addon4',
          billing_system_version: '1751205029785',
          is_attached: true,
          price_variant_id: 'variant-2',
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 10,
              amount: 193,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: 20,
              amount: 200,
              strikethrough_amount: null,
            },
            {
              starting_unit: 21,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 10,
              amount: 193,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: 20,
              amount: 200,
              strikethrough_amount: null,
            },
            {
              starting_unit: 21,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon4-INR-Every-2-months',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1745227409042',
              amount: null,
              tiers: [
                {
                  starting_unit: 1,
                  ending_unit: 10,
                  amount: 2293,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 11,
                  ending_unit: 20,
                  amount: 200,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 21,
                  ending_unit: null,
                  amount: 0,
                  strikethrough_amount: null,
                },
              ],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7N9ZP1958B2EVDNKWH',
      name: 'Addon3',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon3',
      billing_system_version: '1742453057832',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7NBYQCPXYH8GMWETHY',
          name: 'Addon3 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 0,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 0,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon3-INR-Monthly',
          billing_system_item_id: 'Addon3',
          billing_system_version: '1742453068527',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7NX434V8BSD4KE0CP9',
          name: 'Addon3 USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 20,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 20,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Addon3-USD-Monthly',
          billing_system_item_id: 'Addon3',
          billing_system_version: '1746647519898',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7NPK7V8P15CZPGP25N',
      name: 'Addon5',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon5',
      billing_system_version: '1742453109224',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7NPQXT9WHCQJ73QJ0Z',
          name: 'Addon5 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 450,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 450,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon5-INR-Monthly',
          billing_system_item_id: 'Addon5',
          billing_system_version: '1742453118085',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JXKVR1M5EX3995QBZESCB75C',
          name: 'Addon5 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 30,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 30,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon5-INR-Monthly-Variant3',
          billing_system_item_id: 'Addon5',
          billing_system_version: '1749749567947',
          is_attached: true,
          price_variant_id: 'variant-3',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon5-INR-Every-2-months',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749749595043',
              amount: 1,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JXKVR1M5PJ7NRXAM34KE7TVG',
          name: 'Addon5 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 400,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 400,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon5-INR-Yearly',
          billing_system_item_id: 'Addon5',
          billing_system_version: '1749748282441',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JXKVR1M5VC1TA36Y2FKQEFT2',
          name: 'Addon5 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 333333,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 333333,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon5-INR-Yearly-Variant3',
          billing_system_item_id: 'Addon5',
          billing_system_version: '1749748978786',
          is_attached: true,
          price_variant_id: 'variant-3',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon5-INR-Every-3-months',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749749646285',
              amount: 2,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7P84PD039RGJMHVAWP',
      name: 'Addon6',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon6',
      billing_system_version: '1742453128906',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7PN7Z7P2WZW33DJFRW',
          name: 'Addon6 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon6-INR-Monthly-Stairstep',
          billing_system_item_id: 'Addon6',
          billing_system_version: '1747660243124',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.stairstep,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 5,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 10,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 5,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 10,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QCF37QCY7YWJAK7Y0',
          name: 'Addon6 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 400,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 400,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon6-INR-Yearly',
          billing_system_item_id: 'Addon6',
          billing_system_version: '1745315817029',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QFJMTNW0WNF1G14RR',
          name: 'Addon6 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 2000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 2000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon6-INR-Monthly',
          billing_system_item_id: 'Addon6',
          billing_system_version: '1746631121586',
          is_attached: true,
          price_variant_id: 'variant-2',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QJ5Y2FGYSPQ2225EX',
          name: 'Addon6 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon6-INR-Yearly',
          billing_system_item_id: 'Addon6',
          billing_system_version: '1745315851343',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 330,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 120,
              amount: 2222,
              strikethrough_amount: null,
            },
            {
              starting_unit: 121,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 330,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 120,
              amount: 2222,
              strikethrough_amount: null,
            },
            {
              starting_unit: 121,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7PSRZE0CN3EH5Q36JY',
      name: 'Addon2',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon2',
      billing_system_version: '1742452993443',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7P7DDCPG9GP0RZ7K5V',
          name: 'Addon2 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 20,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 20,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon2-INR-Monthly',
          billing_system_item_id: 'Addon2',
          billing_system_version: '1744361084306',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7PCD7R0E4N6J6QECT9',
          name: 'Addon2 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 50,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 50,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon2-INR-Yearly',
          billing_system_item_id: 'Addon2',
          billing_system_version: '1744361203810',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7PGRD1GKF6J3M2VQW8',
          name: 'Addon2 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 2,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 2,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon2-INR-Monthly',
          billing_system_item_id: 'Addon2',
          billing_system_version: '1744361110834',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7PVRPVZB9VS1ATGZJS',
          name: 'Addon2 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon2-INR-Yearly',
          billing_system_item_id: 'Addon2',
          billing_system_version: '1745315639336',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.stairstep,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 10,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 30,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 10,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 30,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7QB1JGYHZRENHPGK9C',
      name: 'Addon1',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Addon1',
      billing_system_version: '1742449175326',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7Q9J78MXZYFNE8KQ33',
          name: 'Addon1 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-INR-Monthly',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1742541401698',
          is_attached: true,
          price_variant_id: 'fluxus-variant',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon1-INR-Monthly',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1745215598138',
              amount: 400,
              tiers: [],
            },
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon1-INR-Monthly',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1744573500535',
              amount: 1500,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QC6C9QCGDEVWNC1DW',
          name: 'Addon1 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-INR-Yearly',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1746793715558',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QEWFXSNEAQCSFZAPX',
          name: 'Addon1 USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 20,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 20,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-USD-Monthly',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1747048608247',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon1-USD-Every-2-months',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1750687302891',
              amount: 20,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QHMBR0W2TPVM8NPF3',
          name: 'Addon1',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 90,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 90,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-273',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1750181365363',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon1-273',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1744573500456',
              amount: 200,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QJH6FVYKPZ8AX1RP3',
          name: 'Addon1 INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-INR-Yearly',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1745914931328',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QNJXQAD19B7AZ9VKP',
          name: 'Addon1-var3',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 16,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 16,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-584',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1750059192736',
          is_attached: true,
          price_variant_id: 'variant-3',
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7QQBR7CFJ57JPFWEB4',
          name: 'Addon1 INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Addon1-INR-Monthly-Tiered',
          billing_system_item_id: 'Addon1',
          billing_system_version: '1746793606009',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 10,
              amount: 200,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: 20,
              amount: 300,
              strikethrough_amount: null,
            },
            {
              starting_unit: 21,
              ending_unit: null,
              amount: 9,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 10,
              amount: 200,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: 20,
              amount: 300,
              strikethrough_amount: null,
            },
            {
              starting_unit: 21,
              ending_unit: null,
              amount: 9,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Addon1-INR-Every-2-months',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1750750257651',
              amount: null,
              tiers: [
                {
                  starting_unit: 1,
                  ending_unit: 10,
                  amount: 2,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 11,
                  ending_unit: 20,
                  amount: 4,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 21,
                  ending_unit: null,
                  amount: 9,
                  strikethrough_amount: null,
                },
              ],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JVPDAR7QRBC31KF46ACR4X0S',
      name: 'Extra Space Addon',
      description: 'Extra space Addon it is',
      billing_system: 'chargebee',
      billing_system_id: 'Extra-Space-Addon',
      billing_system_version: '1745316750424',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'addon',
      prices: [
        {
          id: '01JVPDAR7QATZWWSETGGPN4YDP',
          name: 'Extra Space Addon USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-USD-Yearly',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745928866737',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7R5C56DB6XK59P6F4P',
          name: 'Extra Space Addon USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 300,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 300,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-USD-Monthly',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745316953194',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7R82GPB7NTMRPGQ7EM',
          name: 'Extra Space Addon fluxus',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-305',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745317762877',
          is_attached: true,
          price_variant_id: 'fluxus-variant',
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7RA2YBCRA0HZH9PZR8',
          name: 'Extra Space Addon USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-USD-Monthly-Stairstep',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745833851004',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.stairstep,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 40,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 200,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 20,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 40,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 200,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7RTGB8JQ970S7YGHE8',
          name: 'Extra Space Addon INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 100,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 100,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-INR-Yearly',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745487927097',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'Extra-Space-Addon-INR-Yearly',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1745835108817',
              amount: 20000,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7RWW5PBFQ4M0K8XGW3',
          name: 'Extra Space Addon INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-INR-Monthly-Tiered',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745316791067',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 30,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 50,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 30,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 50,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 0,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7RY7TN70S9PQW5N42Y',
          name: 'Extra Space Addon INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-INR-Yearly-Volume',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745316814598',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.volume,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 50,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 100,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 200,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 5,
              amount: 50,
              strikethrough_amount: null,
            },
            {
              starting_unit: 6,
              ending_unit: 10,
              amount: 100,
              strikethrough_amount: null,
            },
            {
              starting_unit: 11,
              ending_unit: null,
              amount: 200,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JVPDAR7RYPM9KTZ24TGDPHAE',
          name: 'Extra Space Addon INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Extra-Space-Addon-INR-Monthly',
          billing_system_item_id: 'Extra-Space-Addon',
          billing_system_version: '1745316768970',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JZQBG31HSBEM2869MTG1NNHA',
      name: 'Charge4',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'Charge4',
      billing_system_version: '1750836963078',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: '01JZQBG31W5ZDF0E54PQW7M1X2',
          name: 'Charge4 INR',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Charge4-INR',
          billing_system_item_id: 'Charge4',
          billing_system_version: '1750836973596',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'Charge4-INR',
              billing_system_item_id: 'Freemium-Plan',
              billing_system_version: '1750923573057',
              amount: 30,
              tiers: [],
            },
            {
              parent_period: 1,
              parent_period_unit: 'year',
              billing_system_id: 'Charge4-INR',
              billing_system_item_id: 'New-Plan',
              billing_system_version: '1750919321723',
              amount: 20,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JZQBG31W1F57EQ34H1CTFD23',
      name: 'Charge2',
      description: 'Charge2 Description',
      billing_system: 'chargebee',
      billing_system_id: 'Charge2',
      billing_system_version: '1747812658196',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: '01JZQBG31XG34SR03Q1K365RD8',
          name: 'Charge2 USD',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'Charge2-USD',
          billing_system_item_id: 'Charge2',
          billing_system_version: '1747812704227',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.stairstep,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 30,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 86,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 100,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 3,
              amount: 30,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: 6,
              amount: 86,
              strikethrough_amount: null,
            },
            {
              starting_unit: 7,
              ending_unit: null,
              amount: 100,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 2,
              parent_period_unit: 'month',
              billing_system_id: 'Charge2-USD',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749480343852',
              amount: null,
              tiers: [
                {
                  starting_unit: 1,
                  ending_unit: 3,
                  amount: 2,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 4,
                  ending_unit: 6,
                  amount: 8,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 7,
                  ending_unit: null,
                  amount: 0,
                  strikethrough_amount: null,
                },
              ],
            },
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'Charge2-USD',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749480320100',
              amount: null,
              tiers: [
                {
                  starting_unit: 1,
                  ending_unit: 3,
                  amount: 35,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 4,
                  ending_unit: 6,
                  amount: 86,
                  strikethrough_amount: null,
                },
                {
                  starting_unit: 7,
                  ending_unit: null,
                  amount: 100,
                  strikethrough_amount: null,
                },
              ],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JZQBG31XZVAQS9788YMYJNMG',
          name: 'Charge2 INR',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'Charge2-INR',
          billing_system_item_id: 'Charge2',
          billing_system_version: '1747812680672',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'Charge2-INR',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749480319333',
              amount: 10,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JZQBG31WMWQ4FR71JRXJS2KA',
      name: 'charge3',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'charge3',
      billing_system_version: '1750320104515',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: '01JZQBG31WSR8F30T1S2JAS3B3',
          name: 'charge3 INR',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: 10,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 10,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'charge3-INR',
          billing_system_item_id: 'charge3',
          billing_system_version: '1750320122404',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: null,
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: '01JZQBG31XX1HV9YDBJZ5M3BQ3',
      name: 'charge1',
      description: null,
      billing_system: 'chargebee',
      billing_system_id: 'charge1',
      billing_system_version: '1742452234540',
      product_family: 'Google-Drive',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: '01JZQBG31X3ZMM7DJV5KHNPA0C',
          name: 'charge1 USD',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: 8,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 8,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'charge1-USD',
          billing_system_item_id: 'charge1',
          billing_system_version: '1747824868523',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'charge1-USD',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1749535068575',
              amount: 8,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: '01JZQBG31X6R92QGYH749Y14AV',
          name: 'charge1 INR',
          type: 'recurring',
          period: null,
          period_unit: null,
          amount: 200,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 200,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'charge1-INR',
          billing_system_item_id: 'charge1',
          billing_system_version: '1750079523199',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'charge1-INR',
              billing_system_item_id: 'Freemium-Plan',
              billing_system_version: '1749536913676',
              amount: 30000,
              tiers: [],
            },
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'charge1-INR',
              billing_system_item_id: 'Premium-Plan',
              billing_system_version: '1749535068554',
              amount: 100,
              tiers: [],
            },
            {
              parent_period: null,
              parent_period_unit: null,
              billing_system_id: 'charge1-INR',
              billing_system_item_id: 'Basic-Plan',
              billing_system_version: '1749532918380',
              amount: 150,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
  ],
  customization: {
    plan_customisations: {
      heading: 'Heading',
      sub_heading: 'Sub Heading',
      mandatory_addon_title: 'Mandatory Addon Title',
      recommended_addon_title: 'Recommended Addon Title',
    },
    show_addons_and_charges: true,
    hide_price_breakdown: false,
    hide_mandatory_addon_prices: false,
    hide_plan_customisation: false,
  },
};

export const samplePricingTableV2 = {
  id: 'pricingTable2',
  name: 'StreamFlix Subscription Plans',
  grouped_by: 'item',
  frequencies: [
    {
      id: '01STREAM_MONTHLY',
      title: 'Monthly',
      period: 1,
      period_unit: 'month',
      is_attached: true,
      display_order: 0,
      price_suffix: 'per month',
      recurring_price_label: 'Renews at {{price}} per month',
      show_monthly_price: false,
    },
    {
      id: '01STREAM_YEARLY',
      title: 'Yearly',
      period: 1,
      period_unit: 'year',
      is_attached: true,
      display_order: 1,
      price_suffix: 'per year',
      recurring_price_label: 'Renews at {{price}} per year',
      show_monthly_price: true,
    },
  ],
  currencies: [
    {
      id: 'USD',
      currency_code: 'USD',
      is_attached: true,
      display_order: 0,
    },
    {
      id: 'INR',
      currency_code: 'INR',
      is_attached: true,
      display_order: 1,
    },
  ],
  items: [
    {
      id: 'basic_streaming_plan',
      customization: {
        name: 'Basic',
        display_name: 'Basic',
        description: 'Perfect for casual viewing',
        features: `<div class="slate-p">What's included</div><ul class="slate-ul"><li class="slate-li"><div class="slate-p">Watch on 1 device at a time</div></li><li class="slate-li"><div class="slate-p">HD (720p) streaming quality</div></li><li class="slate-li"><div class="slate-p">Unlimited movies & TV shows</div></li><li class="slate-li"><div class="slate-p">Watch on phone & tablet</div></li><li class="slate-li"><div class="slate-p"><s class="slate-strikethrough">No offline downloads</s></div></li><li class="slate-li"><div class="slate-p"><s class="slate-strikethrough">No 4K Ultra HD</s></div></li></ul>`,
        highlight: false,
        badge: null,
        action_button: {
          type: 'redirect_to_url',
          url: 'https://streamflix.example.com/subscribe/basic',
          text: 'Get Basic',
        },
        is_custom_amount_text: false,
        custom_amount_text: null,
        custom_amount_sub_text: null,
        quantity_meta: null,
        info_text: 'Great for solo streaming',
      },
      is_metered: false,
      display_order: 0,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'streamflix_basic',
      billing_system_version: '1742300490000',
      is_attached: true,
      product_family: 'StreamFlix',
      item_applicability: 'restricted',
      applicable_items: [
        'addon_extra_device',
        'addon_hbo_channel',
        'addon_showtime_channel',
        'addon_sports_package',
        'addon_4k_upgrade',
        'addon_dvr_storage_basic',
        'addon_dvr_storage_premium',
        'addon_offline_downloads',
        'charge_activation_fee',
        'charge_device_registration',
        'charge_late_payment',
      ],
      attached_addons: [
        {
          billing_system_id: 'charge_activation_fee',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          item_type: 'charge',
          quantity: 1,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: true,
          display_order: 0,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_offline_downloads',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 1,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_4k_upgrade',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 2,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge_device_registration',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          item_type: 'charge',
          quantity: 1,
          type: null,
          charge_on_event: 'subscription_activation',
          chargeOnce: false,
          display_order: 3,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: 'basic_usd_monthly',
          name: 'Basic USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 899,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 899,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-basic-usd-monthly',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'basic_usd_yearly',
          name: 'Basic USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 8999,
          active: true,
          is_attached: true,
          strikethrough_amount: 10788,
          billing_system_amount: 8999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-basic-usd-yearly',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'basic_inr_monthly',
          name: 'Basic INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 74900,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 74900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-basic-inr-monthly',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'basic_inr_yearly',
          name: 'Basic INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 749900,
          active: true,
          is_attached: true,
          strikethrough_amount: 898800,
          billing_system_amount: 749900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-basic-inr-yearly',
          billing_system_item_id: 'streamflix_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
      ],
    },
    {
      id: 'standard_streaming_plan',
      customization: {
        name: 'Standard',
        display_name: 'Standard',
        description: 'Great for families and HD lovers',
        features: `<div class="slate-p">
        <b>What's included</b></div><ul class="slate-ul"><li class="slate-li"><div class="slate-p">Watch on 2 devices at a time</div></li><li class="slate-li"><div class="slate-p">Full HD (1080p) streaming quality</div></li><li class="slate-li"><div class="slate-p">Unlimited movies & TV shows</div></li><li class="slate-li"><div class="slate-p">Watch on all devices</div></li><li class="slate-li"><div class="slate-p">Download on 2 devices</div></li><li class="slate-li"><div class="slate-p"><s class="slate-strikethrough">No 4K Ultra HD</s></div></li></ul>`,
        highlight: true,
        badge: {
          type: 'block',
          text: 'Most Popular',
        },
        action_button: {
          type: 'redirect_to_url',
          url: 'https://streamflix.example.com/subscribe/standard',
          text: 'Get Standard',
        },
        is_custom_amount_text: false,
        custom_amount_text: null,
        custom_amount_sub_text: null,
        quantity_meta: null,
        info_text: 'Perfect for sharing',
      },
      is_metered: false,
      display_order: 1,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'streamflix_standard',
      billing_system_version: '1742300490000',
      is_attached: true,
      product_family: 'StreamFlix',
      item_applicability: 'restricted',
      applicable_items: [
        'addon_extra_device',
        'addon_hbo_channel',
        'addon_showtime_channel',
        'addon_sports_package',
        'addon_4k_upgrade',
        'addon_dvr_storage_basic',
        'addon_dvr_storage_premium',
        'addon_parental_controls',
        'charge_activation_fee',
        'charge_late_payment',
      ],
      attached_addons: [
        {
          billing_system_id: 'addon_offline_downloads',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 2,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 0,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_hbo_channel',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 1,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_sports_package',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 2,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge_activation_fee',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          item_type: 'charge',
          quantity: 1,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: true,
          display_order: 3,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: 'standard_usd_monthly',
          name: 'Standard USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1399,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1399,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-standard-usd-monthly',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'standard_usd_yearly',
          name: 'Standard USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 13999,
          active: true,
          is_attached: true,
          strikethrough_amount: 16788,
          billing_system_amount: 13999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-standard-usd-yearly',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'standard_inr_monthly',
          name: 'Standard INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 116900,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 116900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-standard-inr-monthly',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'standard_inr_yearly',
          name: 'Standard INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1169900,
          active: true,
          is_attached: true,
          strikethrough_amount: 1402800,
          billing_system_amount: 1169900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-standard-inr-yearly',
          billing_system_item_id: 'streamflix_standard',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
      ],
    },
    {
      id: 'premium_streaming_plan',
      customization: {
        name: 'Premium',
        display_name: 'Premium',
        description: 'The ultimate streaming experience',
        features: `<div class="slate-p">What's included</div><ul class="slate-ul"><li class="slate-li"><div class="slate-p">Watch on 4 devices at a time</div></li><li class="slate-li"><div class="slate-p">4K Ultra HD + HDR streaming</div></li><li class="slate-li"><div class="slate-p">Unlimited movies & TV shows</div></li><li class="slate-li"><div class="slate-p">Watch on all devices</div></li><li class="slate-li"><div class="slate-p">Download on 4 devices</div></li><li class="slate-li"><div class="slate-p">Spatial audio support</div></li><li class="slate-li"><div class="slate-p">Early access to new releases</div></li></ul>`,
        highlight: false,
        badge: {
          type: 'block',
          text: 'Best Value',
        },
        action_button: {
          type: 'redirect_to_url',
          url: 'https://streamflix.example.com/subscribe/premium',
          text: 'Get Premium',
        },
        is_custom_amount_text: false,
        custom_amount_text: null,
        custom_amount_sub_text: null,
        quantity_meta: null,
        info_text: 'Best quality & sharing',
      },
      is_metered: false,
      display_order: 2,
      period: null,
      period_unit: null,
      billing_system: 'chargebee',
      billing_system_id: 'streamflix_premium',
      billing_system_version: '1742300490000',
      is_attached: true,
      product_family: 'StreamFlix',
      item_applicability: 'restricted',
      applicable_items: [
        'addon_extra_device',
        'addon_hbo_channel',
        'addon_showtime_channel',
        'addon_sports_package',
        'addon_dvr_storage_basic',
        'addon_dvr_storage_premium',
        'addon_parental_controls',
        'addon_family_profiles',
        'charge_late_payment',
      ],
      attached_addons: [
        {
          billing_system_id: 'addon_offline_downloads',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 4,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 0,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_4k_upgrade',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'mandatory',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 1,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_extra_device',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 2,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 2,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'addon_dvr_storage_premium',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          item_type: 'addon',
          quantity: 1,
          type: 'recommended',
          charge_on_event: null,
          chargeOnce: null,
          display_order: 3,
          removed_from_checkout: null,
        },
        {
          billing_system_id: 'charge_device_registration',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          item_type: 'charge',
          quantity: 4,
          type: null,
          charge_on_event: 'subscription_creation',
          chargeOnce: false,
          display_order: 4,
          removed_from_checkout: null,
        },
      ],
      prices: [
        {
          id: 'premium_usd_monthly',
          name: 'Premium USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-premium-usd-monthly',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'premium_usd_yearly',
          name: 'Premium USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 19999,
          active: true,
          is_attached: true,
          strikethrough_amount: 23988,
          billing_system_amount: 19999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-premium-usd-yearly',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'premium_inr_monthly',
          name: 'Premium INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 166900,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 166900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-premium-inr-monthly',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
        {
          id: 'premium_inr_yearly',
          name: 'Premium INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1669900,
          active: true,
          is_attached: true,
          strikethrough_amount: 2002800,
          billing_system_amount: 1669900,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'streamflix-premium-inr-yearly',
          billing_system_item_id: 'streamflix_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: 7,
          trial_period_unit: 'day',
        },
      ],
    },
  ],
  addons: [
    {
      id: 'addon_extra_device',
      name: 'Extra Device',
      description: 'Add an extra simultaneous streaming device',
      billing_system: 'chargebee',
      billing_system_id: 'addon_extra_device',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Extra Device',
        display_name: 'Extra Streaming Device',
      },
      prices: [
        {
          id: 'addon_extra_device_usd_monthly',
          name: 'Extra Device USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 499,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 499,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'extra-device-usd-monthly',
          billing_system_item_id: 'addon_extra_device',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'extra-device-usd-monthly',
              billing_system_item_id: 'streamflix_premium',
              billing_system_version: '1742300490000',
              amount: 399,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_extra_device_usd_yearly',
          name: 'Extra Device USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 4999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 4999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'extra-device-usd-yearly',
          billing_system_item_id: 'addon_extra_device',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_extra_device_inr_monthly',
          name: 'Extra Device INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 41700,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 41700,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'extra-device-inr-monthly',
          billing_system_item_id: 'addon_extra_device',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'extra-device-inr-monthly',
              billing_system_item_id: 'streamflix_premium',
              billing_system_version: '1742300490000',
              amount: 33300,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_extra_device_inr_yearly',
          name: 'Extra Device INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 417000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 417000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'extra-device-inr-yearly',
          billing_system_item_id: 'addon_extra_device',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_hbo_channel',
      name: 'HBO Max',
      description: 'Premium HBO Max channel with exclusive content',
      billing_system: 'chargebee',
      billing_system_id: 'addon_hbo_channel',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'HBO Max',
        display_name: 'HBO Max Premium Channel',
      },
      prices: [
        {
          id: 'addon_hbo_usd_monthly',
          name: 'HBO Max USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1499,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1499,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'hbo-max-usd-monthly',
          billing_system_item_id: 'addon_hbo_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_hbo_usd_yearly',
          name: 'HBO Max USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 14999,
          active: true,
          is_attached: true,
          strikethrough_amount: 17988,
          billing_system_amount: 14999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'hbo-max-usd-yearly',
          billing_system_item_id: 'addon_hbo_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_hbo_inr_monthly',
          name: 'HBO Max INR Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 125000,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 125000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'hbo-max-inr-monthly',
          billing_system_item_id: 'addon_hbo_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_hbo_inr_yearly',
          name: 'HBO Max INR Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1250000,
          active: true,
          is_attached: true,
          strikethrough_amount: 1500000,
          billing_system_amount: 1250000,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'hbo-max-inr-yearly',
          billing_system_item_id: 'addon_hbo_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_showtime_channel',
      name: 'Showtime',
      description: 'Showtime premium channel',
      billing_system: 'chargebee',
      billing_system_id: 'addon_showtime_channel',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Showtime',
        display_name: 'Showtime Premium',
      },
      prices: [
        {
          id: 'addon_showtime_usd_monthly',
          name: 'Showtime USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 1099,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1099,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'showtime-usd-monthly',
          billing_system_item_id: 'addon_showtime_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_showtime_usd_yearly',
          name: 'Showtime USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 10999,
          active: true,
          is_attached: true,
          strikethrough_amount: 13188,
          billing_system_amount: 10999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'showtime-usd-yearly',
          billing_system_item_id: 'addon_showtime_channel',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_sports_package',
      name: 'Sports Package',
      description: 'Live sports channels and on-demand replays',
      billing_system: 'chargebee',
      billing_system_id: 'addon_sports_package',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Sports Package',
        display_name: 'Live Sports Package',
      },
      prices: [
        {
          id: 'addon_sports_usd_monthly_tiered',
          name: 'Sports Package USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'sports-package-usd-monthly-tiered',
          billing_system_item_id: 'addon_sports_package',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 1,
              amount: 1999,
              strikethrough_amount: null,
            },
            {
              starting_unit: 2,
              ending_unit: 3,
              amount: 1799,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: null,
              amount: 1599,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 1,
              amount: 1999,
              strikethrough_amount: null,
            },
            {
              starting_unit: 2,
              ending_unit: 3,
              amount: 1799,
              strikethrough_amount: null,
            },
            {
              starting_unit: 4,
              ending_unit: null,
              amount: 1599,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_sports_usd_yearly',
          name: 'Sports Package USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 19999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 19999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'sports-package-usd-yearly',
          billing_system_item_id: 'addon_sports_package',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_4k_upgrade',
      name: '4K Upgrade',
      description: 'Unlock 4K Ultra HD streaming quality',
      billing_system: 'chargebee',
      billing_system_id: 'addon_4k_upgrade',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: '4K Upgrade',
        display_name: '4K Ultra HD Quality',
      },
      prices: [
        {
          id: 'addon_4k_usd_monthly',
          name: '4K Upgrade USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 599,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 599,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: '4k-upgrade-usd-monthly',
          billing_system_item_id: 'addon_4k_upgrade',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_4k_usd_yearly',
          name: '4K Upgrade USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 5999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 5999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: '4k-upgrade-usd-yearly',
          billing_system_item_id: 'addon_4k_upgrade',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_dvr_storage_basic',
      name: 'Basic DVR Storage',
      description: '50 hours of cloud DVR storage',
      billing_system: 'chargebee',
      billing_system_id: 'addon_dvr_storage_basic',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Basic DVR Storage',
        display_name: '50 Hours DVR Storage',
      },
      prices: [
        {
          id: 'addon_dvr_basic_usd_monthly_volume',
          name: 'Basic DVR Storage USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'dvr-basic-usd-monthly-volume',
          billing_system_item_id: 'addon_dvr_storage_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.volume,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 50,
              amount: 499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 51,
              ending_unit: 100,
              amount: 899,
              strikethrough_amount: null,
            },
            {
              starting_unit: 101,
              ending_unit: null,
              amount: 1299,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 50,
              amount: 499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 51,
              ending_unit: 100,
              amount: 899,
              strikethrough_amount: null,
            },
            {
              starting_unit: 101,
              ending_unit: null,
              amount: 1299,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_dvr_basic_usd_yearly',
          name: 'Basic DVR Storage USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 4999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 4999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'dvr-basic-usd-yearly',
          billing_system_item_id: 'addon_dvr_storage_basic',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_dvr_storage_premium',
      name: 'Premium DVR Storage',
      description: 'Unlimited cloud DVR storage',
      billing_system: 'chargebee',
      billing_system_id: 'addon_dvr_storage_premium',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Premium DVR Storage',
        display_name: 'Unlimited DVR Storage',
      },
      prices: [
        {
          id: 'addon_dvr_premium_usd_monthly_stairstep',
          name: 'Premium DVR Storage USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'dvr-premium-usd-monthly-stairstep',
          billing_system_item_id: 'addon_dvr_storage_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.stairstep,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 1,
              amount: 1499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 2,
              ending_unit: 2,
              amount: 2499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 3,
              ending_unit: null,
              amount: 2999,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 1,
              amount: 1499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 2,
              ending_unit: 2,
              amount: 2499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 3,
              ending_unit: null,
              amount: 2999,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_dvr_premium_usd_yearly',
          name: 'Premium DVR Storage USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 14999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 14999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'dvr-premium-usd-yearly',
          billing_system_item_id: 'addon_dvr_storage_premium',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_offline_downloads',
      name: 'Offline Downloads',
      description: 'Download content for offline viewing',
      billing_system: 'chargebee',
      billing_system_id: 'addon_offline_downloads',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Offline Downloads',
        display_name: 'Offline Download Access',
      },
      prices: [
        {
          id: 'addon_offline_usd_monthly',
          name: 'Offline Downloads USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 299,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 299,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'offline-downloads-usd-monthly',
          billing_system_item_id: 'addon_offline_downloads',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'offline-downloads-usd-monthly',
              billing_system_item_id: 'streamflix_standard',
              billing_system_version: '1742300490000',
              amount: 0,
              tiers: [],
            },
            {
              parent_period: 1,
              parent_period_unit: 'month',
              billing_system_id: 'offline-downloads-usd-monthly',
              billing_system_item_id: 'streamflix_premium',
              billing_system_version: '1742300490000',
              amount: 0,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_offline_usd_yearly',
          name: 'Offline Downloads USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 2999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 2999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'offline-downloads-usd-yearly',
          billing_system_item_id: 'addon_offline_downloads',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_parental_controls',
      name: 'Parental Controls',
      description: 'Advanced parental control features',
      billing_system: 'chargebee',
      billing_system_id: 'addon_parental_controls',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Parental Controls',
        display_name: 'Advanced Parental Controls',
      },
      prices: [
        {
          id: 'addon_parental_usd_monthly',
          name: 'Parental Controls USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 199,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 199,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'parental-controls-usd-monthly',
          billing_system_item_id: 'addon_parental_controls',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_parental_usd_yearly',
          name: 'Parental Controls USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 1999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 1999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'parental-controls-usd-yearly',
          billing_system_item_id: 'addon_parental_controls',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'addon_family_profiles',
      name: 'Family Profiles',
      description: 'Create up to 6 personalized profiles',
      billing_system: 'chargebee',
      billing_system_id: 'addon_family_profiles',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'addon',
      customization: {
        name: 'Family Profiles',
        display_name: 'Multiple User Profiles',
      },
      prices: [
        {
          id: 'addon_family_usd_monthly',
          name: 'Family Profiles USD Monthly',
          type: 'recurring',
          period: 1,
          period_unit: 'month',
          amount: 399,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 399,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'family-profiles-usd-monthly',
          billing_system_item_id: 'addon_family_profiles',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'addon_family_usd_yearly',
          name: 'Family Profiles USD Yearly',
          type: 'recurring',
          period: 1,
          period_unit: 'year',
          amount: 3999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 3999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'family-profiles-usd-yearly',
          billing_system_item_id: 'addon_family_profiles',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
  ],
  charges: [
    {
      id: 'charge_activation_fee',
      name: 'Activation Fee',
      description: 'One-time account activation fee',
      billing_system: 'chargebee',
      billing_system_id: 'charge_activation_fee',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: 'charge_activation_usd',
          name: 'Activation Fee USD',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: 999,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 999,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'activation-fee-usd',
          billing_system_item_id: 'charge_activation_fee',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'year',
              billing_system_id: 'activation-fee-usd',
              billing_system_item_id: 'streamflix_premium',
              billing_system_version: '1742300490000',
              amount: 0,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'charge_activation_inr',
          name: 'Activation Fee INR',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: 83400,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 83400,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'activation-fee-inr',
          billing_system_item_id: 'charge_activation_fee',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.flat_fee,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [
            {
              parent_period: 1,
              parent_period_unit: 'year',
              billing_system_id: 'activation-fee-inr',
              billing_system_item_id: 'streamflix_premium',
              billing_system_version: '1742300490000',
              amount: 0,
              tiers: [],
            },
          ],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'charge_device_registration',
      name: 'Device Registration',
      description: 'Per-device registration charge',
      billing_system: 'chargebee',
      billing_system_id: 'charge_device_registration',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: 'charge_device_usd',
          name: 'Device Registration USD',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: 199,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 199,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'device-registration-usd',
          billing_system_item_id: 'charge_device_registration',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'charge_device_inr',
          name: 'Device Registration INR',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: 16600,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: 16600,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'device-registration-inr',
          billing_system_item_id: 'charge_device_registration',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.per_unit,
          tiers: null,
          billing_system_tiers: null,
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
    {
      id: 'charge_late_payment',
      name: 'Late Payment Fee',
      description: 'Fee for late subscription payments',
      billing_system: 'chargebee',
      billing_system_id: 'charge_late_payment',
      billing_system_version: '1742300490000',
      product_family: 'StreamFlix',
      is_metered: false,
      item_type: 'charge',
      prices: [
        {
          id: 'charge_late_usd_tiered',
          name: 'Late Payment Fee USD',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'USD',
          billing_system: 'chargebee',
          billing_system_id: 'late-payment-usd-tiered',
          billing_system_item_id: 'charge_late_payment',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 7,
              amount: 499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 8,
              ending_unit: 14,
              amount: 999,
              strikethrough_amount: null,
            },
            {
              starting_unit: 15,
              ending_unit: null,
              amount: 1499,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 7,
              amount: 499,
              strikethrough_amount: null,
            },
            {
              starting_unit: 8,
              ending_unit: 14,
              amount: 999,
              strikethrough_amount: null,
            },
            {
              starting_unit: 15,
              ending_unit: null,
              amount: 1499,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
        {
          id: 'charge_late_inr_tiered',
          name: 'Late Payment Fee INR',
          type: 'one_time',
          period: null,
          period_unit: null,
          amount: null,
          active: true,
          is_attached: true,
          strikethrough_amount: null,
          billing_system_amount: null,
          currency: 'INR',
          billing_system: 'chargebee',
          billing_system_id: 'late-payment-inr-tiered',
          billing_system_item_id: 'charge_late_payment',
          billing_system_version: '1742300490000',
          is_attached: true,
          price_variant_id: null,
          pricing_model: PricingModel.tiered,
          tiers: [
            {
              starting_unit: 1,
              ending_unit: 7,
              amount: 41600,
              strikethrough_amount: null,
            },
            {
              starting_unit: 8,
              ending_unit: 14,
              amount: 83400,
              strikethrough_amount: null,
            },
            {
              starting_unit: 15,
              ending_unit: null,
              amount: 125000,
              strikethrough_amount: null,
            },
          ],
          billing_system_tiers: [
            {
              starting_unit: 1,
              ending_unit: 7,
              amount: 41600,
              strikethrough_amount: null,
            },
            {
              starting_unit: 8,
              ending_unit: 14,
              amount: 83400,
              strikethrough_amount: null,
            },
            {
              starting_unit: 15,
              ending_unit: null,
              amount: 125000,
              strikethrough_amount: null,
            },
          ],
          quantity_meta: null,
          differential_prices: [],
          trial_period: null,
          trial_period_unit: null,
        },
      ],
    },
  ],
  customization: {
    plan_customisations: {
      heading: 'Choose Your Plan',
      sub_heading:
        'Stream unlimited entertainment. Watch anywhere. Cancel anytime.',
      mandatory_addon_title: 'Required Add-ons',
      recommended_addon_title: 'Enhance Your Experience',
    },
    show_addons_and_charges: true,
    hide_price_breakdown: false,
    hide_mandatory_addon_prices: false,
    hide_plan_customisation: false,
  },
};

export const samplePricingPageExperience = {
  id: '123',
  session: '123',
  version: '1.0.0',
  company: {
    name: 'Sample Company',
    logo: 'https://www.google.com',
    user_avatar: 'https://www.google.com',
    user_name: 'Sample User',
    brandingLogoActivated: true,
  },
  layout: {
    id: '123',
    style_overlay: {},
    cards: [
      {
        type: 'Card',
        id: 'header-card',
        name: 'Header Card',
        version: '1.0',
        deploy: 'inline',
        template: 'simple_header',
        requires: {
          header: {
            title: 'Choose the perfect plan for you',
            details:
              'Compare features and pricing to find the best fit for your needs',
          },
        },
      },
    ],
    pricing_table: undefined,
  },
  integrations: {},
};
